import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { loadSettings, updateSettings } from 'store/settings/settings.thunk';
import TreasuresView from 'shared/constants/treasures-view';

type SettingsState = {
  language: string;
  dateFormat: string;
  timezone: string;
  subscribed: boolean | null;
  siderStatus: undefined | 'open' | 'collapsed';
  treasuresView: TreasuresView;
  emailBannerDismissed: boolean;
};

const initialState: SettingsState = {
  language: 'en',
  dateFormat: 'MM/DD/YYYY',
  timezone: '',
  subscribed: null,
  siderStatus: undefined,
  treasuresView: TreasuresView.CARD,
  emailBannerDismissed: false,
};

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    dismissEmailBanner: (state) => {
      state.emailBannerDismissed = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadSettings.fulfilled, (state, action) => {
      const newSettings = action.payload;

      newSettings.language != null && (state.language = newSettings.language);
      newSettings.dateFormat != null && (state.dateFormat = newSettings.dateFormat);
      newSettings.siderStatus != null && (state.siderStatus = newSettings.siderStatus);
      newSettings.treasuresView != null && (state.treasuresView = newSettings.treasuresView);
    });

    builder.addCase(updateSettings.fulfilled, (state, action) => {
      const newSettings = action.payload;

      newSettings.language != null && (state.language = newSettings.language);
      newSettings.dateFormat != null && (state.dateFormat = newSettings.dateFormat);
      newSettings.siderStatus != null && (state.siderStatus = newSettings.siderStatus);
      newSettings.treasuresView != null && (state.treasuresView = newSettings.treasuresView);
      newSettings.timezone != null && (state.timezone = newSettings.timezone);
      if ('subscribed' in newSettings) state.subscribed = newSettings.subscribed ?? null;
    });
  },
});

export const { dismissEmailBanner } = settingsSlice.actions;

export const selectLanguage = (state: RootState) => state.settings.language;

export const selectDateFormat = (state: RootState) => state.settings.dateFormat;

export const selectTimezone = (state: RootState) => state.settings.timezone;

export const selectSubscribed = (state: RootState) => state.settings.subscribed;

export const selectSiderStatus = (state: RootState) => state.settings.siderStatus;

export const selectTreasuresView = (state: RootState) => state.settings.treasuresView;

export const selectEmailBannerDismissed = (state: RootState) => state.settings.emailBannerDismissed;

export default settingsSlice.reducer;
